/* import __COLOCATED_TEMPLATE__ from './phone-dialler-contact-list.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Signature<T extends { id: string | number }> {
  Element: HTMLElement;
  Args: {
    header: string;
    isLoading: boolean;
    hasSearched: boolean;
    noMatchesText?: string;
    emptyText?: string;
    list: T[];
    actionProcessingId?: number | string;
    actionLabel: string;
    actionProcessingLabel: string;
    onClick: (item: T) => void | Promise<void>;
    checkPhoneNumberValid?: (item: T) => boolean;
  };
  Blocks: {
    icon: [T];
    text: [T];
    additionInfo: [T];
  };
}

export default class PhoneDiallerContactList<T extends { id: string | number }> extends Component<
  Signature<T>
> {
  @service declare intl: IntlService;

  get isProcessing() {
    return !!this.args.actionProcessingId;
  }

  get showEmptyState() {
    return !this.args.list?.length;
  }

  /**
   * Checks if the call button should be disabled for a given item
   */
  isCallButtonDisabled = (item: T): boolean => {
    if (this.isProcessing) {
      return true;
    }

    // If validation function is provided, use it to check phone number validity
    if (this.args.checkPhoneNumberValid) {
      return !this.args.checkPhoneNumberValid(item);
    }

    // If no validation function provided, don't disable the button
    return false;
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::PhoneDiallerContactList': typeof PhoneDiallerContactList;
    'inbox2/calling/phone-dialler-contact-list': typeof PhoneDiallerContactList;
  }
}
